// @ts-check

import { finiteNumber } from '../../shared/math.js?v=20260706d';

export function normalizeBounds(bounds) {
  if (!bounds || typeof bounds !== 'object') return null;
  if (!['minX', 'maxX', 'minZ', 'maxZ'].every(key => Number.isFinite(Number(bounds[key])))) return null;
  return {
    minX: Number(bounds.minX),
    maxX: Number(bounds.maxX),
    minZ: Number(bounds.minZ),
    maxZ: Number(bounds.maxZ)
  };
}

export function boundsFromState(state) {
  const metadataBounds = normalizeBounds(state?.metadata?.bounds);
  if (metadataBounds) return metadataBounds;
  const position = state?.position || state;
  if (!Number.isFinite(Number(position?.x)) || !Number.isFinite(Number(position?.z))) return null;
  const x = finiteNumber(position.x, 0);
  const z = finiteNumber(position.z, 0);
  return { minX: x, maxX: x, minZ: z, maxZ: z };
}

export function mergeBounds(a, b) {
  const left = normalizeBounds(a);
  const right = normalizeBounds(b);
  if (!left) return right;
  if (!right) return left;
  return {
    minX: Math.min(left.minX, right.minX),
    maxX: Math.max(left.maxX, right.maxX),
    minZ: Math.min(left.minZ, right.minZ),
    maxZ: Math.max(left.maxZ, right.maxZ)
  };
}

export function boundsCenter(bounds) {
  const normalized = normalizeBounds(bounds);
  return normalized
    ? {
        x: (normalized.minX + normalized.maxX) / 2,
        z: (normalized.minZ + normalized.maxZ) / 2
      }
    : null;
}

export function transformSnapshotBounds(snapshot = []) {
  return (snapshot || []).reduce((bounds, entry) => mergeBounds(bounds, boundsFromState(entry?.state || entry)), null);
}
